<script setup lang="ts">
/**
 * App.vue — minimal entry point (thin shell selector).
 *
 * Renders:
 *   - <AppShell><router-view/></AppShell> for authenticated, non-public routes.
 *   - Bare <router-view/> for public routes (login) and unauthenticated state.
 *
 * AppShell internally owns the topbar, sidebar, and /auth/me fetch via useMe().
 * No layout logic, no topbar, no .content max-width constraint here (FS-1.2).
 *
 * Note: with the nested route structure in router/index.ts, AppShell is the
 * parent route component for all authenticated routes. This App.vue simply
 * renders the top-level <router-view/>, which resolves to AppShell for
 * authenticated routes and LoginView for /login (public, top-level).
 *
 * Design §2.1, spec FS-1.2, FS-1.3.
 */
</script>

<template>
  <!--
    Top-level router-view: resolves to AppShell (for shell-nested routes)
    or LoginView (for /login, which is top-level and not nested under AppShell).
    AppShell handles all layout and nesting; App.vue stays completely thin.
    FS-1.2: no layout logic here.
  -->
  <router-view />
</template>
